<template>
  <div> <!-- Element rădăcină -->
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('gestiune.reports')"></general-top-bar> -->
      <div id="outer-container">
          <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
              <div class="card-content">
                  <div class="clearfix row pad-lf-10 pad-rg-10">
                      <!-- <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.isStock }"
                        @click="changeView('isStock')"
                      >{{$t('gestiune.stocks')}}</a> -->
                      <!-- <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.isStockHistory }"
                        @click="changeView('isStockHistory')"
                      >{{$t('gestiune.stocksHistory')}}</a> -->
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.nirs }"
                        @click="changeView('nirs')"
                      >{{$t('gestiune.reportStock')}}</a>
                      <!-- <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.inventory }"
                        @click="changeView('inventory')"
                      >{{$t('gestiune.reportInventory')}}</a> -->
                       <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.purchase }"
                        @click="changeView('purchase')"
                      >{{$t('gestiune.purchase')}}</a>
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.consumption }"
                        @click="changeView('consumption')"
                      >{{$t('gestiune.consumption')}}</a>
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.production }"
                        @click="changeView('production')"
                      >{{$t('gestiune.production')}}</a>
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.balance }"
                        @click="changeView('balance')"
                      >{{$t('gestiune.BalanceReport')}}</a>
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.stocLaZi }"
                        @click="changeView('stocLaZi')"
                      >{{$t('gestiune.stocLaZi')}}</a>
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.productMix }"
                        @click="changeView('productMix')"
                      >{{$t('gestiune.productMix')}}</a>
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.salesMarkup }"
                        @click="changeView('salesMarkup')"
                      >{{$t('gestiune.salesMarkup')}}</a>
                      <!-- <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInViewElement.productMix }"
                        @click="changeView('productMix')"
                      >{{$t('gestiune.productMix')}}</a> -->
                  </div>
              </div>
          </div>
      </div>
      <div v-if="isInViewElement.isStock">
        <StockReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions" :key="'nirs'" />
      </div>
      <div v-if="isInViewElement.isStockHistory">
        <StockHistoryReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div>
      <div v-if="isInViewElement.nirs">
        <NirsReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div>
      <div v-if="isInViewElement.inventory">
        <InventoryReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div>
      <!-- <div v-if="isInViewElement.productMix">
        <ProductMixReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div> -->
      <div v-if="isInViewElement.purchase">
        <PurchaseReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div>
      <div v-if="isInViewElement.consumption">
        <ConsumptionReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div>
      <div v-if="isInViewElement.production">
        <ProductionReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div>
      <div v-if="isInViewElement.balance">
        <BalanceReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div>
      <div v-if="isInViewElement.stocLaZi">
        <NirsReport
          :groupedLocations="groupedLocations"
          :gestiuneOptions="gestiuneOptions"
          :extraProp="true"
          :key="'stocLaZi'"
        />
      </div>
      <div v-if="isInViewElement.productMix">
        <MixReport/>
      </div>
      <div v-if="isInViewElement.salesMarkup">
        <SalesMarkupReport :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
      </div>
  </div>
</template>

<script>
	/* eslint-disable */
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import StockReport from 'src/components/Dashboard/Views/Management/Reports/StockReport.vue'
  import StockHistoryReport from 'src/components/Dashboard/Views/Management/Reports/StockHistoryReport.vue'
  import NirsReport from 'src/components/Dashboard/Views/Management/Reports/NirsReport.vue'
  import InventoryReport from 'src/components/Dashboard/Views/Management/Reports/InventoryReport.vue'
  import ProductMixReport from 'src/components/Dashboard/Views/Management/Reports/ProductMixReport.vue'
  import PurchaseReport from 'src/components/Dashboard/Views/Management/Reports/PurchaseReport.vue'
  import ConsumptionReport from 'src/components/Dashboard/Views/Management/Reports/ConsumptionReport.vue'
  import ProductionReport from 'src/components/Dashboard/Views/Management/Reports/ProductionReport.vue'
  import BalanceReport from 'src/components/Dashboard/Views/Management/Reports/BalanceReport.vue'
  import MixReport from 'src/components/Dashboard/Views/Reports/Versions/2/MixedReport.vue'
  import SalesMarkupReport from 'src/components/Dashboard/Views/Management/Reports/SalesMarkupReport.vue'
  export default {
    components: {
      // GeneralTopBar,
      StockReport,
      StockHistoryReport,
      NirsReport,
      InventoryReport,
      ProductMixReport,
      PurchaseReport,
      ConsumptionReport,
      ProductionReport,
      BalanceReport,
      MixReport,
      SalesMarkupReport
    },
    props: {
      gestiuneOptions: {
        type: Array,
        required: true
      },
      groupedLocations: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        isInViewElement: {
		      isStock: false,
		      isStockHistory: false,
          nirs: true,
          inventory: false,
          productMix: false,
          purchase: false,
          consumption: false,
          production: false,
          balance: false,
          salesMarkup: false
		    }
      }
    },
    created () {
    },
		methods: {
		  allVarsFalse () {
		    Object.keys(this.isInViewElement).forEach(key => {
		      this.isInViewElement[key] = false
		    })
		  },
		  changeView (varName) {
		    this.allVarsFalse()
		    this.isInViewElement[varName] = true
		  }
		}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementReports.vue